import { useStore as useStore$1 } from "react-redux";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import { composeWithDevTools as composeWithDevTools$1 } from "redux-devtools-extension/logOnly";
import { persistStore, persistReducer } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
import createSagaMiddleware, { END } from "redux-saga";
import { ReducersRegistry } from "./Reducer/Reducer/ReducersRegistry.js";
import { SagaRegistry } from "./Saga/Saga/SagaRegistry.js";
const sagaMiddleware = createSagaMiddleware();
const bindMiddleware = (middleware) => {
  return applyMiddleware(...middleware);
};
const persistConfig = {
  key: "grandvision_store",
  whitelist: ["checkout", "cart"],
  storage: sessionStorage
};
const getRootReducer = (reducers, isServer) => {
  const rootReducer = combineReducers({ ...reducers });
  if (isServer) {
    return rootReducer;
  }
  return persistReducer(persistConfig, rootReducer);
};
const initStore = (initialState = {}, { isServer }) => {
  const rootReducer = getRootReducer(ReducersRegistry.reducers, isServer);
  const devToolsOptions = {
    serialize: true
  };
  const devTools = process.env.NODE_ENV !== "production" ? composeWithDevTools(devToolsOptions) : composeWithDevTools$1(devToolsOptions);
  const plainStore = createStore(
    rootReducer,
    initialState,
    devTools(bindMiddleware([sagaMiddleware]))
  );
  const persistor = persistStore(plainStore);
  let store;
  if (!isServer) {
    store = Object.assign(plainStore, {
      persistor,
      // Make sure we run the sagas that have been registered before the store is initialized
      runningSagas: SagaRegistry.sagas.map(sagaMiddleware.run),
      runSaga: sagaMiddleware.run,
      setSagaContext: sagaMiddleware.setContext,
      close: async () => {
        store.dispatch(END);
        await Promise.all(store.runningSagas.map((t) => t.toPromise()));
      }
    });
  } else {
    store = Object.assign(plainStore, {
      persistor,
      runningSagas: [],
      close: () => Promise.resolve()
    });
    SagaRegistry.listener = (sagas) => {
      store.runningSagas.push(sagaMiddleware.run(sagas));
    };
  }
  ReducersRegistry.listener = (reducers) => {
    store.replaceReducer(getRootReducer(reducers, isServer));
  };
  return store;
};
function useStore() {
  return useStore$1();
}
export {
  initStore,
  persistConfig,
  useStore
};
//# sourceMappingURL=store.js.map
